<template>
  <div class="">
    <h5 class="header page_header page_bg_b content header_title_page">
      <span>Part.5 专业推荐</span>
    </h5>
    <h6 class="page_title_2 content">
      <span>专业推荐</span><span class="arrow"></span>
    </h6>
    <div class="header_detail_box content">
      <p class="header_detail">
        专业推荐基于普通高等学校本科专业设置，对除军事学门类外的92个专业类别进行人格、兴趣和能力评定，建立本科专业库并作为推荐来源。此部分将你在人格特性、智能水平和职业兴趣上的测评结果与专业库进行对照，得到你与各个专业类别的匹配指数，亦即下文呈现的推荐指数，指数越大，说明你与此类专业的培养目标和素质要求等越适合，更可能在未来的学习中收获较好的满意度和学业成就。由于单独个体较难与专业类别达到完全适配，因此应重点关注不同专业类之间推荐指数的相对差异，而非绝对大小。
      </p>
    </div>
    <div class="line_box2 content">
      <p>
        <img
          src="../../../../../public/imgs/cepingreport/page_feng.png"
          alt=""
        />
        你的专业推荐结果及有关专业信息如下：
      </p>
    </div>

    <div class="page_2_img content">
      <img src="../../../../../public/imgs/cepingreport/page_2.png" alt="" />
      <div>
          <div
        class="page_jy page_2_absolute"
        v-for="(p, index) in item"
        :key="index"
        :class="'page_jy' + index"
      >
        <i :class="'page_jy_icon' + index"></i>
        <div class="page_fenlei colorB" style="width:170px">
          <p v-if="p">{{ p.name }}</p>
          <p v-if="p">推荐指数:{{ p.index }}</p>
        </div>
      </div>
      </div>
    </div>
    <div class="" v-for="(p, index) in professionalRecommend" :key="index">
      <div class="zhuanye_one content" :class="'color' + ++index">
        <div class="small_title_box career_page">
          <span class="career_page"></span>
          <i class="zy_book" :class="'zy_book' + index"></i>
          <div class="small_titled">
            {{ p.num }}
          </div>
          <div class="line" :class="'line' + index"></div>
          <div class="page_number">
            {{ p.name }}
          </div>
        </div>
      </div>
      <div class="table content">
        <div class="gridtable">
          <p>具体专业及代码</p>
          <div class="professionCode">
            <div
              v-for="t in p.professionCode"
              style="width: 33%; display: flex; align-items: center"
            >
              <i :class="'radiR' + index"></i
              ><span>{{ t.name }} {{ t.code }}</span>
            </div>
          </div>
        </div>
      </div>
      <h5 class="page_m content" :key="index">
        以<span  :class="'color' + index">{{ p.detail.name }}</span
        >专业为例，对该专业介绍如下：
      </h5>
      <div class="page_js content">
        <div class="page_zyjs bg_color1">专业介绍</div>
        <ul>
          <li>
            {{ p.detail.desc }}
          </li>
        </ul>
      </div>
      <div class="page_js content">
        <div class="page_zyjs bg_color2">知识能力</div>
        <p v-html="p.detail.knowledgeAbility"></p>
      </div>
      <div class="page_js content">
        <div class="page_zyjs bg_color3">主干课程</div>
        <ul>
          <li>
            {{ p.detail.mainCourse }}
          </li>
        </ul>
      </div>
      <div class="page_js content">
        <div class="page_zyjs bg_color4">就业方向</div>
        <ul>
          <li>
            {{ p.detail.employmentDirection }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    professionalRecommend: {
      type: Array,
    },
  },
  data() {
    return {
      newArr: [],
      list: ["推荐专业一", "推荐专业二", "推荐专业三", "推荐专业四"],
      item: [],
    };
  },
  computed: {
    resolve(){
      return this.item = [this.professionalRecommend[1],this.professionalRecommend[0],this.professionalRecommend[2]];
    }
  },
  watch: {
    // professionalRecommend(val) {
    //   let arr = val;
    //   let item = arr[0];
    //   arr[0] = arr[1];
    //   arr[1] = item;
    //   this.professionalRecommend = arr;
    // },
    professionalRecommend:function(newVal,oldVal){
      this.item = newVal
      this.item = [this.professionalRecommend[1],this.professionalRecommend[0],this.professionalRecommend[2]];
     
    }
  },
  created() {
    
   
  },
  mounted() {},
  computed: {
    // sortstudents:function(){
    // 		//	return this.sortByKey(this.professionalRecommend,'index')
    //     var arr=this.sortByKey(this.proFessionalEwcommend,"index")
    //     console.log(arr)
    //     var newArr = []
    //     newArr.push(arr[1],arr[0],arr[2])
    //     return newArr
    // 				}
  },
  methods: {
    // sortByKey(array,key){
    //   return array.sort(function(a,b){
    // 					var x = a[key];
    // 					var y = b[key];
    // 					console.log(y)
    // 					return((x<y)?1:((x<y)?-1:0));
    // 			})
    // }
    // sortKey() {
    //     function compare(property) {
    //         return function (a, b) {
    //             var value1 = a[property];
    //             var value2 = b[property];
    //             return value1 - value2;
    //         };
    //     }
    //     console.log(this.professionalRecommend)
    //     var oldArr=this.professionalRecommend.sort(compare('index'))
    //     console.log(oldArr)
    //   //var oldArr = this.compare.sort(this.professionalRecommend,"index");
    //   this.newArr.push(oldArr[1]);
    //   this.newArr.push(oldArr[0]);
    //   this.newArr.push(oldArr[2]);
    //   console.log(this.newArr);
    // },
  },
};
</script>

<style scoped>
@import "./report.css";

.zhuanye_one .small_titled,
.zhuanye_one .page_number {
  font-size: 20px;
}

.radiR1 {
  background: #f29149;
}
.radiR2 {
  background: #00b3f0;
}
.radiR3 {
  background: #aacf00;
}

h5.header {
  background-color: #19b1c4;
}

h5.header {
  color: #fff;
  font-size: 24px;
  text-align: left;
  margin-bottom: 30px;
  line-height: 50px;
  padding-left: 15px;
}
.page_title_2 {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  height: 32px;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  margin-bottom: 10px;
}
.page_title_2 .arrow {
}
.page_title_2 span {
  line-height: 32px;
  font-size: 20px;
  font-weight: 700;
}
.page_title_2 .arrow {
  display: block;
  margin-left: 10px;
  width: 0;
  height: 0;
  border-top: 9px solid transparent;
  /* border-left: 14px solid #feae3b; */
  border-left: 14px solid #19b1c4;
  border-bottom: 9px solid transparent;
}
.header_detail_box .header_detail {
  text-indent: 2em;
  line-height: 32px;
  font-size: 15px;
  color: #4f4e4e;
}
.line_box2 {
  margin-top: 40px;
}
.page_2_img {
  margin-top: 100px;
  position: relative;
}
.page_jy0 {
  top: -15px;
  left: 47px;
  color: #00b3f0;
}
.page_jy1 {
  top: -58px;
  left: 260px;
  color: #f29149;
}
.page_jy2 {
  right: 52px;
  top: 5px;
  color: #aacf00;
}
.page_jy_icon0 {
  display: inline-block;
  width: 40px;
  height: 40px;
  background: url("../../../../../public/imgs/cepingreport/page_2_2.png")
    no-repeat;
  background-size: cover;
  vertical-align: bottom;
}
.page_jy_icon1 {
  display: inline-block;
  width: 40px;
  height: 40px;
  background: url("../../../../../public/imgs/cepingreport/page_2_1.png")
    no-repeat;
  background-size: cover;
  vertical-align: bottom;
}
.page_jy_icon2 {
  display: inline-block;
  width: 40px;
  height: 40px;
  background: url("../../../../../public/imgs/cepingreport/page_2_3.png")
    no-repeat;
  background-size: cover;
  vertical-align: bottom;
}
.zhuanye_one {
  margin-top: 45px;
}

.page_2_absolute {
  position: absolute;
}
.page_fenlei {
  display: inline-block;
}
.page_fenlei p:first-child {
  font-size: 16px;
  font-weight: 600;
}
.page_fenlei p:last-child {
  font-size: 14px;
  font-weight: 600;
}

.small_title_box {
  font-size: 16px;
  /* color: #3AB3C1; */
  line-height: 28px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  font-weight: 600;
}
.small_title_box .small_titled {
  padding-right: 20px;
  padding-left: 15px;
}

.small_title_box .page_number {
  padding-left: 10px;
  /* font-size: 18px; */
}
.table {
  margin-top: 25px;
}
.table .gridtable {
  font-family: verdana, arial, sans-serif;
  font-size: 14px;
  color: #333333;
  border: 1px dashed #dfdede;
}
.table .gridtable .professionCode {
  display: flex;
  flex-wrap: wrap;
}
.gridtable p {
  background: #dfdede;
  padding: 10px;
  border-bottom: 1px dashed #dfdede;
  box-sizing: border-box;
  font-weight: 600;
}
.table .gridtable .professionCode div {
  border-bottom: 1px dashed #dfdede;
  padding: 10px;
  box-sizing: border-box;
}
.table .gridtable .professionCode div i {
  display: inline-block;
  width: 5px;
  height: 5px;
  border-radius: 50%;
}
.table .gridtable .professionCode div span {
  margin-left: 10px;
}

table.gridtable tr th {
  padding: 10px;
  font-size: 16px;
  font-weight: 600;
}
table.gridtable td {
  border-width: 1px;
  padding: 10px;
  border-style: dashed;
  border-color: #dfdede;
  background-color: #ffffff;
}
table.gridtable td i {
  display: inline-block;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #1ca4b6;
}
table.gridtable td span {
  margin-left: 10px;
}
.page_m {
  font-size: 16px;
  margin-top: 40px;
}
/* .page_m span {
  color: #3ab3c1;
} */
.line {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  margin: auto 0;
}
.zy_book {
  display: inline-block;
  width: 37px;
  height: 33px;

  background-size: cover;
}
.page_js {
  margin-top: 50px;
  height: auto;
  background: #f5f5f5;
  border-radius: 6px;
  padding: 30px 15px;
  box-sizing: border-box;
  position: relative;
}
.page_js ul li {
  text-indent: 2em;
  line-height: 2;
  font-size: 14px;
  color: #969696;
}
.page_js p {
  line-height: 2;
  font-size: 14px;
  color: #969696;
}
.page_zyjs {
  width: 90px;
  height: 30px;
  /* background: #3ab3c1; */
  border-radius: 6px;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: -15px;
}
</style>